import Joi from 'joi';

export const HolidaySchema = Joi.object({
  name: Joi.string().required(),
  date: Joi.date().required(),
});
